<template>
  <el-dialog title="编辑" :visible.sync="dialogVisible" width="50%" append-to-body @close="close"
    :close-on-click-modal="false">
    <el-form :model="ruleForm" :rules="rules" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="产品类别" prop="parentId">
        <el-select class="main-select-tree" ref="itemRef" clearable @clear="setValueNull" multiple @remove-tag="
            (data) => {
              delTag(data);
            }
          " v-model="ruleForm.parentName" style="width: 400px" name="option 1">
          <el-option v-for="(index, item) in optionData(classList)" :label="item.label" :value="item.id"
            :key="item.label" style="display: none" />
          <div class="searchWrap">
            <div class="searchItem">
              <span class="searchName">名称</span>
              <el-input placeholder="输入名称关键字进行过滤" v-model="filterText" style="margin: 0 5px; width: 98%">
              </el-input>
            </div>
            <div class="searchItem">
              <span class="searchName">规格</span>
              <el-input placeholder="输入规格关键字进行过滤" v-model="specName" style="margin: 0 5px; width: 98%">
              </el-input>
            </div>
            <div class="searchItem">
              <span class="searchName">件号/存货编号</span>
              <el-input placeholder="输入规格关键字进行过滤" v-model="partNumber" style="margin: 0 5px; width: 98%">
              </el-input>
            </div>
          </div>
          <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props="treeProps" highlight-current
            @node-click="
              (data, node, item) => handleNodeClick(data, node, item)
            " :expand-on-click-node="expandOnClickNode" collapse-tags :lazy="true" :load="load"
            :filter-node-method="filterNode" />
        </el-select>
      </el-form-item>
      <el-form-item label="标识码">
        <el-input v-model="ruleForm.handle" disabled></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <!--        <el-upload-->
        <!--            class="avatar-uploader"-->
        <!--            :action="uploadUrl"-->
        <!--            :headers="upParams"-->
        <!--            :show-file-list="false"-->
        <!--            :on-success="handleSuccess">-->
        <!--          <img v-if="ruleForm.img" :src="ossUrl + ruleForm.img" class="avatar">-->
        <!--          <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        <!--        </el-upload>-->
        <el-upload :action="uploadUrl" :headers="upParams" list-type="picture-card"
          :class="{ disabled: uploadDisabled }" :on-remove="handleRemove" :on-success="handleSuccess" :file-list="
            ruleForm.img ? [{ url: ossUrl + ruleForm.img, uid: 1 }] : []
          " :limit="1">
          <i slot="default" class="el-icon-plus"></i>
          <!-- <div slot="tip" class="el-upload__tip">上传图片</div> -->
        </el-upload>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="ruleForm.remarks" rows="2" style="width: 400px" />
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="ruleForm.sorting"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="edit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { editStoreCode } from "@/api/storeCode.js";
  import { pageClassList } from "@/api/customPageClass.js";
  import { fetchClassList } from "@/api/storeWarehouse.js";
  export default {
    name: "editCode",
    components: {},
    props: [],
    data() {
      let token = localStorage.getItem("token");
      return {
        title: "编辑容器码",
        upParams: {
          token: token,
        },
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        ruleForm: {
          parentId: [],
          parentName: [],
          id: "",
          name: "",
          handle: "",
          classIds: [],
          sorting: 0,
          img: "",
          remarks: "",
        },
        rules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          parentId: [
            { required: true, message: "请选择产品类别", trigger: "blur" },
          ],
        },
        id: "",
        dialogVisible: false,
        classList: [],
        treeProps: {
          children: "children",
          label: "allName",
          isLeaf: "isLeaf",
        },
        expandOnClickNode: false,
        parentId: "",
        codeType: 0,
        filterText: "",
        specName: "",
        allData: "",
        partNumber: "",
        isInitialRender: true
      };
    },
    onShow() { },
    created() { },
    mounted() { },
    watch: {
      filterText(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.codeType,
          parentId: "",
          name: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      specName(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.codeType,
          parentId: "",
          specName: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      partNumber(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.codeType,
          parentId: "",
          partNumber: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
    },
    computed: {
      dynamicRules() {
        return (index) => {
          return [
            {
              required: true,
              message: "这是必填项",
              trigger: "blur",
            },
          ];
        };
      },
      uploadDisabled() {
        return this.ruleForm.img ? true : false;
      },
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.allName.indexOf(value) !== -1;
      },
      searchItem(params, val) {
        pageClassList(params)
          .then((res) => {
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            if (res.data.list && res.data.list.length == 0) {
              this.$message.error("没有找到相关的产品类别");
            }
            if (val) {
              this.classList =
                res.data.list && res.data.list.length > 0
                  ? res.data.list
                  : this.allData;
            } else {
              this.classList = this.allData;
            }
          })
          .catch((error) => {
            console.error("接口调用出错:", error);
          });
      },
      load(node, resolve) {
        if (this.isInitialRender) {
          this.isInitialRender = false;
          return resolve([]);
        }
        if ("顶级" == node.data.allName) {
          return resolve(node.data.children);
        } else {
          let params = {
            noPage: true,
            type: 0,
            name: this.name,
            classType: this.codeType,
            status: this.storeStatus,
            parentId: node.data.id,
          };
          pageClassList(params).then((res) => {
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            node.data.children = res.data.list;
            return resolve(res.data.list);
          });
        }
      },
      handleRemove(file, fileList) {
        this.fileList = [];
        this.ruleForm.img = "";
      },
      handleSuccess(response, file, fileList) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.ruleForm.img = file.response.data;
      },
      getClassList(id) {
        fetchClassList({ codeId: id }).then((res) => {
          if (res.data) {
            res.data.forEach((item) => {
              this.ruleForm.parentId.push({
                id: item.classId,
                name: item.className,
                parentId: item.parentId,
              });
              this.ruleForm.parentName.push(
                item.className + (item.specName ? "(" + item.specName + ")" : "")
              );
            });
          }
        });
      },
      getAllClass(codeType) {
        this.codeType = codeType;
        let params = {
          pageNum: 1,
          pageSize: 200,
          type: 0,
          classType: codeType,
        };
        pageClassList(params).then((res) => {
          res.data.list.forEach((item) => {
            item.isLeaf = !item.hasChildren;
            let namePart = item.name ? `${item.name}` : "";
            let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
            let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
            let specNamePart = item.specName ? `(${item.specName})` : "";
            item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
          });
          this.classList = [
            {
              id: "",
              allName: "顶级",
              isLeaf: res.data.list.length > 0 ? false : true,
              children: res.data.list,
            },
          ];
          this.allData = JSON.parse(JSON.stringify(this.classList));
        });
      },
      init(data) {
        this.reset();
        this.ruleForm.id = data.id;
        this.ruleForm.handle = data.handle;
        this.ruleForm.name = data.name;
        this.ruleForm.sorting = data.sorting;
        this.ruleForm.img = data.img;
        this.ruleForm.remarks = data.remarks;
        this.dialogVisible = true;
      },
      reset() {
        this.ruleForm.parentId = [];
        this.ruleForm.parentName = [];
      },
      edit() {
        this.ruleForm.classIds = this.ruleForm.parentId.map((val) => val.id);
        if (!this.ruleForm.classIds || this.ruleForm.classIds.length <= 0) {
          this.$message.error("请选择产品");
          return;
        }
        editStoreCode(this.ruleForm).then((res) => {
          this.dialogVisible = false;
          this.$message.success("操作成功");
        });
      },
      close() {
        this.$emit("getList");
      },
      handleNodeClick(data, node, item) {
        if (data.children && data.children.length > 0) {
          this.$message.error("请选择子级节点");
          return;
        }
        let number = this.ruleForm.parentId.findIndex((val) => val.id == data.id);
        if (number && number == -1) {
          if (!data.parentId) {
            this.ruleForm.parentId = this.ruleForm.parentId.filter(
              (val) => val.parentId != data.id
            );
          } else {
            let number1 = this.ruleForm.parentId.findIndex(
              (val) => val.id == data.parentId
            );
            if (number1 && number1 != -1) {
              this.$message.error("该节点父级已被选择");
              return;
            }
          }
          this.ruleForm.parentId.push({
            id: data.id,
            name: data.name,
            parentId: data.parentId,
          });
        }
        this.ruleForm.parentName = this.ruleForm.parentId.map((val) => val.name);
        //   this.ruleForm.name = this.ruleForm.parentName.map(val => val).join(",")
        this.$nextTick(() => {
          this.$refs["itemRef"].blur();
        });
      },
      setValueNull(index) {
        this.ruleForm.parentId = [];
        this.ruleForm.parentName = [];
      },
      optionData(array, result = []) {
        array.forEach((item) => {
          result.push({
            label: item.specName
              ? item.name + "(" + item.specName + ")"
              : item.name,
            value: item.id,
            hasChild: item.children && item.children.length !== 0,
          });
          if (item.children && item.children.length !== 0) {
            this.optionData(item.children, result);
          }
        });
        return JSON.parse(JSON.stringify(result));
      },
      delTag(item) {
        let number = this.ruleForm.parentId.findIndex((val) => val.name == item);
        this.ruleForm.parentId.splice(number, 1);
        this.ruleForm.parentName = this.ruleForm.parentId.map((val) => val.name);
        //   this.ruleForm.name = this.ruleForm.parentName.map(val => val).join(",")
      },
    },
  };
</script>

<style lang="scss" scoped>
  .main-select-tree {
    /deep/.el-input__inner {
      height: 80px !important;
    }

    /deep/ .el-select__tags {
      display: flex;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: 80px;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }

  /deep/ .el-upload--text {
    width: 150px !important;
    height: 150px !important;
  }

  /deep/ .disabled .el-upload--picture-card {
    display: none;
  }

  .corporateInformation-view {
    padding: 16px 24px;
  }

  /deep/.el-tabs__content {
    background: #ffffff;
  }

  .searchItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    .searchName {
      width: 130px;
      font-size: 14px;
    }
  }

  .tree-container {
    height: 400px;
    overflow-y: auto;
  }

  .virtual-scroller {
    width: 100%;
  }
</style>